(() => {
  'use strict';
  document.addEventListener('DOMContentLoaded', async () => {
    const dataEl = document.getElementById('CBV_ScentData');
    if (!dataEl) return;
    const el = id => document.getElementById(id);
    const grid = el('CBV_ScentGrid');
    const search = el('CBV_ScentSearch');
    const familiesEl = el('CBV_FamilyFilters');
    const lettersEl = el('CBV_AlphaFilters');
    const status = el('CBV_FavoritesStatus');
    const login = el('CBV_FavoritesLogin');
    const favoritesTab = el('CBV_MyFavorites');
    const allTab = el('CBV_AllFragrances');
    const state = { search: '', family: 'all', letter: 'all', favorites: false };
    let scents = [];
    let ids = new Set();
    let token = '';
    let accountReady = false;
    let busy = false;
    let readSequence = 0;
    let searchTimer;
    const normalize = value => (value || '').trim().toLowerCase();
    const endpoint = dataEl.dataset.favoritesEndpoint;

    function message(text, signIn = false) {
      status.textContent = text;
      login.hidden = !signIn;
    }
    async function api(options = {}) {
      const response = await fetch(endpoint, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(20000), ...options });
      let data;
      try { data = await response.json(); } catch { throw new Error('APP_NOT_CONFIGURED'); }
      if (!response.ok) throw new Error(data.error || 'SAVE_FAILED');
      if (!Array.isArray(data.ids) || typeof data.writeToken !== 'string') throw new Error('INVALID_RESPONSE');
      return data;
    }
    function explain(error) {
      if (error.message === 'SIGN_IN_REQUIRED') {
        accountReady = false; ids = new Set(); token = '';
        message('Sign in to your customer account to save and view favorites.', true);
      } else {
        message('Favorites are temporarily unavailable. Your saved list has not been replaced. Please try again.');
      }
    }
    async function loadFavorites() {
      if (busy) return;
      const sequence = ++readSequence;
      try {
        const data = await api();
        if (sequence !== readSequence || busy) return;
        ids = new Set(data.ids); token = data.writeToken; accountReady = true;
        message('');
      } catch (error) { if (sequence !== readSequence || busy) return; explain(error); }
      render();
    }
    function updateHeart(button, scent) {
      const saved = ids.has(scent.id);
      button.textContent = saved ? '♥' : '♡';
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? 'Remove' : 'Save'} ${scent.name}${saved ? ' from' : ' to'} favorites`);
      button.disabled = busy;
    }
    function render() {
      const filtered = scents.filter(scent =>
        scent.name.toLowerCase().includes(state.search.toLowerCase()) &&
        (state.family === 'all' || scent.family === state.family) &&
        (state.letter === 'all' || scent.name.trim().toUpperCase().startsWith(state.letter)) &&
        (!state.favorites || (accountReady && ids.has(scent.id)))
      );
      el('CBV_ResultCount').textContent = `Showing ${filtered.length} scent${filtered.length === 1 ? '' : 's'}`;
      grid.replaceChildren();
      const fragment = document.createDocumentFragment();
      for (const scent of filtered) {
        const card = document.createElement('article');
        card.className = 'cbv-lib-card';
        const family = document.createElement('div');
        family.className = 'cbv-lib-card__family'; family.textContent = scent.family;
        const titleRow = document.createElement('div'); titleRow.className = 'cbv-lib-card__title-row';
        const title = document.createElement('a'); title.className = 'cbv-lib-card__title';
        title.textContent = scent.name; title.href = scent.url;
        const heart = document.createElement('button');
        heart.type = 'button'; heart.className = 'cbv-lib-heart'; heart.dataset.fragranceId = scent.id;
        updateHeart(heart, scent);
        titleRow.append(title, heart);
        const link = document.createElement('a'); link.className = 'cbv-lib-card__action';
        link.href = scent.url; link.textContent = 'View Scent →';
        card.append(family, titleRow, link); fragment.append(card);
      }
      grid.append(fragment);
      const empty = el('CBV_EmptyState');
      empty.hidden = filtered.length !== 0;
      grid.hidden = filtered.length === 0;
      empty.querySelector('h3').textContent = state.favorites ? 'No favorites to show' : 'No scents found';
      empty.querySelector('p').textContent = state.favorites
        ? (accountReady ? 'Save scents using the hearts, or clear your search and filters to see more favorites.' : 'Sign in to view the fragrances saved to your account.')
        : "We couldn't find a match. Try checking your spelling or browsing by 'All Scents'.";
      for (const btn of familiesEl.querySelectorAll('[data-filter]')) btn.classList.toggle('is-active', btn.dataset.filter === state.family);
      for (const btn of lettersEl.querySelectorAll('[data-letter]')) btn.classList.toggle('is-active', btn.dataset.letter === state.letter);
      el('CBV_MobileToggleLabel').textContent = state.family === 'all' ? 'Filter by Family' : `Family: ${state.family}`;
      el('CBV_ClearSearch').hidden = !state.search;
      for (const [tab, selected] of [[allTab, !state.favorites], [favoritesTab, state.favorites]]) {
        tab.classList.toggle('is-active', selected); tab.setAttribute('aria-pressed', String(selected));
      }
    }
    grid.addEventListener('click', async event => {
      const button = event.target.closest('[data-fragrance-id]');
      if (!button || busy) return;
      if (!accountReady) {
        await loadFavorites();
        if (!accountReady) return;
      }
      const id = button.dataset.fragranceId;
      const saved = !ids.has(id);
      busy = true;
      readSequence++;
      grid.querySelectorAll('.cbv-lib-heart').forEach(heart => { heart.disabled = true; });
      message(saved ? 'Saving favorite…' : 'Removing favorite…');
      try {
        const data = await api({ method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id, saved, writeToken: token }) });
        ids = new Set(data.ids); token = data.writeToken;
        message(saved ? 'Added to My Favorites.' : 'Removed from My Favorites.');
      } catch (error) { explain(error); }
      finally {
        busy = false; render();
        const replacement = [...grid.querySelectorAll('[data-fragrance-id]')].find(heart => heart.dataset.fragranceId === id);
        (replacement || favoritesTab).focus();
      }
    });
    allTab.addEventListener('click', () => { state.favorites = false; render(); });
    favoritesTab.addEventListener('click', () => { state.favorites = true; render(); loadFavorites(); });
    el('CBV_FavoritesRetry').addEventListener('click', loadFavorites);
    search.addEventListener('input', event => {
      state.search = event.target.value;
      clearTimeout(searchTimer); searchTimer = setTimeout(render, 120);
    });
    el('CBV_ClearSearch').addEventListener('click', () => { search.value = ''; state.search = ''; render(); search.focus(); });
    familiesEl.addEventListener('click', event => {
      const button = event.target.closest('[data-filter]'); if (!button) return;
      state.family = button.dataset.filter; render();
      if (window.innerWidth < 769) {
        el('CBV_MobileFilterToggle').classList.remove('is-open');
        el('CBV_MobileFilterToggle').setAttribute('aria-expanded', 'false');
        familiesEl.classList.remove('is-open');
      }
    });
    lettersEl.addEventListener('click', event => {
      const button = event.target.closest('[data-letter]'); if (!button) return;
      state.letter = button.dataset.letter; render();
    });
    el('CBV_MobileFilterToggle').addEventListener('click', () => {
      const open = el('CBV_MobileFilterToggle').classList.toggle('is-open');
      el('CBV_MobileFilterToggle').setAttribute('aria-expanded', String(open)); familiesEl.classList.toggle('is-open', open);
    });
    el('CBV_ResetFilters').addEventListener('click', () => {
      Object.assign(state, { search: '', family: 'all', letter: 'all', favorites: false }); search.value = ''; render();
    });
    try {
      scents = JSON.parse(dataEl.textContent);
      const pages = Number(dataEl.dataset.pages);
      // Limit concurrency to avoid flooding Shopify with requests.
      for (let page = 1; page <= pages; page++) {
        if (page === Number(dataEl.dataset.currentPage)) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', dataEl.dataset.sectionId);
        url.searchParams.set(dataEl.dataset.pageParam, String(page));
        const response = await fetch(url, { signal: AbortSignal.timeout(20000) });
        if (!response.ok) throw new Error('LIBRARY_LOAD_FAILED');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const payload = doc.getElementById('CBV_ScentData');
        if (!payload) throw new Error('LIBRARY_LOAD_FAILED');
        scents.push(...JSON.parse(payload.textContent));
      }
      scents = [...new Map(scents.map(scent => [scent.id, scent])).values()];
      const families = [...new Set(scents.map(scent => scent.family))].sort();
      for (const family of families) {
        const button = document.createElement('button'); button.type = 'button';
        button.className = 'cbv-lib-pill'; button.dataset.filter = family; button.textContent = family; familiesEl.append(button);
      }
      for (const letter of 'ABCDEFGHIJKLMNOPQRSTUVWXYZ') {
        const button = document.createElement('button'); button.type = 'button';
        button.className = 'cbv-lib-alpha-link'; button.dataset.letter = letter; button.textContent = letter; lettersEl.append(button);
      }
      const aliases = { 'bakery-gourmand': 'Bakery', 'floral-garden': 'Floral', 'fruity-citrus': 'Fruity', 'clean-fresh': 'Clean', 'earthy-woody': 'Earthy', 'holiday-seasonal': 'Christmas', 'perfume-dupes': 'Perfume & Cologne', 'luxury-spa': 'Luxury Spa', tropical: 'Tropical' };
      const params = new URLSearchParams(window.location.search);
      const requested = normalize(params.get('family') || params.get('scent_family'));
      const family = families.find(value => normalize(value) === requested || normalize(value) === normalize(aliases[requested]));
      if (family) state.family = family;
      render(); loadFavorites();
    } catch {
      el('CBV_ResultCount').textContent = 'The full library could not load. Please refresh to try again.';
      message('Please refresh the page before using favorites.');
      allTab.disabled = true; favoritesTab.disabled = true;
    }
    // Refetch after returning from sign-in, another tab, or the browser back button.
    document.addEventListener('visibilitychange', () => { if (!document.hidden && !busy) loadFavorites(); });
    window.addEventListener('pageshow', event => { if (event.persisted && !busy) loadFavorites(); });
  });
})();
